/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const Bluetooth = [["path", { d: "m7 7 10 10-5 5V2l5 5L7 17" }]];

export { Bluetooth as default };
//# sourceMappingURL=bluetooth.js.map
